/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag, BcsFlag } from "../unleash";

export const FlagsFcsBulkDownloadTemplate = {
  bulk_action_download_template_permission_list: new FcsFlag.Flag(false),
  bulk_action_download_template_role: new FcsFlag.Flag(false),
  bulk_action_download_template_account: new FcsFlag.Flag(false),
  bulk_action_download_template_manajemen_pelanggan: new FcsFlag.Flag(false),
  bulk_action_download_template_create_kategori_komoditas: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_syarat_dokumentasi_internasional: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_route_mapping: new FcsFlag.Flag(false),
  bulk_action_download_template_add_commodity: new FcsFlag.Flag(false),
  bulk_action_download_template_create_commodity_surcharge: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_update_commodity_surcharge: new FcsFlag.Flag(
    false
  ),
  bulk_action_donwload_template_leg: new FcsFlag.Flag(false),
  bulk_action_download_template_route_leg: new FcsFlag.Flag(false),
  bulk_action_download_template_route: new FcsFlag.Flag(false),
  bulk_action_download_template_transport_vendor: new FcsFlag.Flag(false),
  bulk_action_download_template_vendor: new FcsFlag.Flag(false),
  bulk_action_download_template_mapping_client_location: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_commodity_stt_and_mapping_group: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_add_new_retail_base_rate: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_bagging_group_location: new FcsFlag.Flag(false),
  bulk_action_download_template_sla_district: new FcsFlag.Flag(false),
  bulk_action_download_template_create_sla_city: new FcsFlag.Flag(false),
  bulk_action_download_template_update_sla_city: new FcsFlag.Flag(false),
  bulk_action_download_template_add_embargo: new FcsFlag.Flag(false),
  bulk_action_download_template_update_embargo: new FcsFlag.Flag(false),
  bulk_action_download_template_update_country: new FcsFlag.Flag(false),
  bulk_action_download_template_add_country: new FcsFlag.Flag(false),
  bulk_action_download_update_city: new FcsFlag.Flag(false),
  bulk_action_download_add_city: new FcsFlag.Flag(false),
  bulk_action_download_update_district: new FcsFlag.Flag(false),
  bulk_action_download_add_district: new FcsFlag.Flag(false),
  bulk_action_download_template_config_cargo: new FcsFlag.Flag(false),
  bulk_action_download_template_awb_reserve: new FcsFlag.Flag(false),
  bulk_action_download_template_region: new FcsFlag.Flag(false),
  bulk_action_download_template_region_city: new FcsFlag.Flag(false),
  bulk_action_download_template_kargo_grouping: new FcsFlag.Flag(false),
  bulk_action_download_template_create_promo_discount: new FcsFlag.Flag(false),
  bulk_action_download_template_update_promo_discount: new FcsFlag.Flag(false),
  bulk_action_download_template_custom_status: new FcsFlag.Flag(false),
  bulk_action_download_template_district_code_vendor_internpack: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_area_keterlambatan: new FcsFlag.Flag(false),
  bulk_action_download_template_update_commodity: new FcsFlag.Flag(false),
  bulk_action_download_template_create_client_branch: new FcsFlag.Flag(false),
  bulk_action_download_template_update_client_branch: new FcsFlag.Flag(false),
  bulk_action_download_template_create_international_vendor_configuration: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_booking_domestik_configuration: new FcsFlag.Flag(
    false
  ),
  bulk_action_download_template_booking_internasional_configuration: new FcsFlag.Flag(
    false
  ),
  bulk_action_hide_international_repair_bulk_booking: new FcsFlag.Flag(false),
  bulk_action_show_download_template: new FcsFlag.Flag(false),
  bulk_action_download_template_pos_limit: new FcsFlag.Flag(false),
  bulk_action_download_template_exchange_rate_config: new FcsFlag.Flag(false),
  bulk_action_download_template_cod_restriction:  new FcsFlag.Flag(false),
  bulk_action_download_template_duty_tax: new FcsFlag.Flag(false),
};

export const FlagsBcsBulkDownloadTemplate = {
  config_bucket_storage: new BcsFlag.StringFlag(
    "https://prd-genesis.s3.ap-southeast-1.amazonaws.com"
  ),
  config_bucket_storage_announcement: new BcsFlag.StringFlag(
    "https://dev-genesis-announcement.s3.ap-southeast-1.amazonaws.com"
  ),
  bulk_booking_download_template_options: new BcsFlag.JSONFlag()
};

export const FlagsBulkDownloadTemplate = {
  ...FlagsFcsBulkDownloadTemplate,
  ...FlagsBcsBulkDownloadTemplate
};

export function initFlagsBulkDownloadTemplate() {
  // register flags with namespaces for better grouping
  FcsFlag.register("FlagsBulkDownloadTemplate", FlagsBulkDownloadTemplate);
  BcsFlag.register("FlagsBulkDownloadTemplate", FlagsBcsBulkDownloadTemplate);
}
